
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning/adventist-materials",
      function () {
        return require("private-next-pages/learning/adventist-materials.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning/adventist-materials"])
      });
    }
  